/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Form_LabelInputs */

const en_options_display_form_label = /** @type {(inputs: Options_Display_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display Settings`)
};

const fr_options_display_form_label = /** @type {(inputs: Options_Display_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres d'affichage`)
};

const de_options_display_form_label = /** @type {(inputs: Options_Display_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigeeinstellungen`)
};

const it_options_display_form_label = /** @type {(inputs: Options_Display_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di visualizzazione`)
};

const ru_options_display_form_label = /** @type {(inputs: Options_Display_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки дисплея`)
};

const es_options_display_form_label = /** @type {(inputs: Options_Display_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de pantalla`)
};

const zh_cn2_options_display_form_label = /** @type {(inputs: Options_Display_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示设置`)
};

const ja_options_display_form_label = /** @type {(inputs: Options_Display_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示設定`)
};

const hi_options_display_form_label = /** @type {(inputs: Options_Display_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रदर्शन सेटिंग्स`)
};

const pt_pt2_options_display_form_label = /** @type {(inputs: Options_Display_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de exibição`)
};

/**
* | output |
* | --- |
* | "Display Settings" |
*
* @param {Options_Display_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_form_label = /** @type {((inputs?: Options_Display_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_form_label(inputs)
	if (locale === "de") return de_options_display_form_label(inputs)
	if (locale === "it") return it_options_display_form_label(inputs)
	if (locale === "ru") return ru_options_display_form_label(inputs)
	if (locale === "es") return es_options_display_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_form_label(inputs)
	if (locale === "ja") return ja_options_display_form_label(inputs)
	if (locale === "hi") return hi_options_display_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_form_label(inputs)
	return en_options_display_form_label(inputs)
});